import MapCard from "../MapCard";
import type { MapFeedItemDTO } from "../../data/types";

type VenueFloatingCardProps = {
  item: MapFeedItemDTO | null;
  onClose: () => void;
};

export function VenueFloatingCard({ item, onClose }: VenueFloatingCardProps) {
  if (!item) return null;

  return (
    <div className="venue-float">
      <button
        className="venue-float-close"
        onClick={onClose}
        aria-label="Close"
        type="button"
      >
        ×
      </button>

      <div
        className="venue-float-card"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <MapCard item={item} />
      </div>
    </div>
  );
}
